<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from './Header.svelte';
    import HeaderThemes from './HeaderThemes.svelte';
    import Footer from './Footer.svelte';
    import FooterThemes from './Footerthemes.svelte';
    import Clipboard from "svelte-clipboard";
    import Fa from 'svelte-fa'
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faSpinner,faCopy } from '@fortawesome/free-solid-svg-icons';
    import Swal from 'sweetalert2'


    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    let loading = false

    let balance = 0.00
    let acc_name =""
    let creditwd = 0

    let isbutton = true
    let bankList = []
    let countBank = 0
    let dataMember
    let isMember = false
    async function getMember() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getmember", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            dataMember = json.payload
            isMember =true
		}
    }
    getMember()
    async function getBank() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/memberbank", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            // bankList = json.payload
            countBank = json.payload
            for await (const iterator of json.payload) {
                let kk = {}
                bankList[iterator._id] = iterator.bankcode+" "+iterator.member_acc
                //bankList.push(kk)
            }
		}
    }
    async function numberonly(evt){
        var e = evt;
        if(window.event){ // IE
            var charCode = e.keyCode;
            if (((charCode < 48) || (charCode > 57)) && (charCode != 13) && (charCode != 8) && charCode != 46) window.event.returnValue = false;
        } else if (e.which) { // Safari 4, Firefox 3.0.4
            var charCode = e.which
            if (((charCode < 48) || (charCode > 57)) && (charCode != 13) && (charCode != 8) && charCode != 46) charCode = e.preventDefault();
        }
    }
    async function getBalanceWD() {
        let isnum = /^\d+$/.test(creditwd.toString());
        if(creditwd==0 || creditwd==undefined || creditwd.toString()=='' || isnum==false){
            Swal.fire(`กรุณาตรวจสอบจำนวนเงินที่ต้องการถอน`);
            return false;
        }

        if(Number(creditwd)<dataMember.dataGroup.min_withdraw){
            Swal.fire(`ยอดถอนขั้นต่ำ `+dataMember.dataGroup.min_withdraw+' บาท');
            return
        }
        if(Number(creditwd)>dataMember.dataGroup.max_withdraw){
            Swal.fire(`ยอดถอนสูงสุด `+dataMember.dataGroup.max_withdraw+' บาท');
            return
        }
        loading = false
        isbutton = false
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getbalance", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            balance = json.payload.balance
            if(Number(balance)>=parseInt(creditwd.toString()) && parseInt(creditwd.toString())>=1){
                // saveWithdraw(parseInt(creditwd.toString()))
                selectBankWithdraw()
            }else{
                isbutton = true
                Swal.fire({
                    heightAuto: false,
                    title: 'ยอดเงินของคุณไม่เพียงพอ!',
                    text: 'ยอดเงิน : '+json.payload.balance,
                    icon: 'error',
                    confirmButtonText: 'OK' 
                })
            }
		} else {
            window.localStorage.clear();
            push('/auth')
            throw new Error(json);
		}
    }
    async function selectBankWithdraw() {
        console.log(countBank)
        
        if(countBank.length==1){
            saveWithdraw(countBank[0]._id)
        }else{
            const { value: fruit } = await Swal.fire({
                title: 'เลือกธนาคารรับเงิน',
                input: 'select',
                inputOptions: bankList,
                inputPlaceholder: 'เลือกธนาคาร',
                showCancelButton: true,
                inputValidator: (value) => {
                    return new Promise((resolve) => {
                        resolve()
                    })
                }
            })
            if (fruit) {
                saveWithdraw(fruit)
            }else{
                Swal.fire(`กรุณาเลือกธนาคารรับเงิน`)
                isbutton = true
            }
        }
        //console.log(fruit)
        
    }
    async function saveWithdraw(bankid) {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/withdraw", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                credit:parseInt(creditwd.toString()),
                bankid:bankid
            })
        })
        const json = await res.json()
        if (json.statusCode==200) {
            Swal.fire({
                heightAuto: false,
                title: 'ทำรายการสำเร็จ!',
                text: '',
                icon: 'success',
                confirmButtonText: 'OK' 
            })
            setTimeout(function(){
                push('/dashboard')
            },1000)
        } else {
            isbutton = true
            Swal.fire({
                    heightAuto: false,
                    title: 'ไม่สามารถทำรายการได้!',
                    text: json.message,
                    icon: 'error',
                    confirmButtonText: 'OK' 
                })
            throw new Error(json);
		}
    }
    let promise
    $: {

        promise = getBank()
    }

</script>
<div class="default-home">
<div class="row pt-2 mb-5" style="background-image: url('{dataSetting.background}'); background-size:cover; background-repeat: no-repeat; background-position: center top;">
    <Header />
    <div class="col-12 text-center mt-3" ><h4 style="background: linear-gradient(135deg, rgb(0 0 0) 0%, rgb(86 80 80) 50%, rgb(131 120 120) 51%, rgb(54 50 50) 71%, rgb(0 0 0) 100%);
        box-shadow: 5px 5px 10px #000 !important;
        line-height: 30px;
        border-radius: 5px;
        padding: 2px 7px;color:gold;">ถอนเงิน</h4></div>
        <div class="col-12" style="min-height: 500px;">
        {#if loading}
        <div class="text-center mt-2" style="">
            <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
        </div>
        {/if}
        {#if !loading}
        <div class="card mt-3 bg-black">
            <div class="card-body text-center pb-5">
                <div class="row">
                    <div class="col-3"></div>
                    <div class="col-6">
                        <img src="{dataSetting.logo}" class="img-fluid">
                    </div>
                </div>
                
                <div class="mb-3">
                    <label for="creditwd" class="form-label text-warning">กรอกจำนวนเงินที่ต้องการถอน</label>
                    <input type="text" class="form-control rounded-pill text-center mb-1" id="creditwd" placeholder="" bind:value={creditwd} on:keypress={()=>numberonly(event)}>
                    {#if isMember}
                    
                    <small class="text-white">ฝากขั้นต่ำ <span class="text-danger">{dataMember.dataGroup.min_withdraw}</span> บาท สูงสุด <span class="text-danger">{dataMember.dataGroup.max_withdraw}</span> บาท</small>
                    
                    {/if}
                </div>
                <div class="row">
                    <div class="col-12 text-center d-grid gap-2">
                        {#if isbutton}
                        <button type="button" class="btn btn-dark rounded-pill btn-gd" on:click={() => getBalanceWD()}>ยืนยันถอนเงิน</button>
                        {/if}
                    </div>
                </div>
                
            </div>
        </div>
        {/if}
    </div>
 
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3 blog-withdraw">
        <HeaderThemes/>
        <div class="col-12 text-center" ><h4 class="head-title">ถอนเงิน</h4></div>
            <div class="col-12" style="min-height: 500px;">
            {#if loading}
            <div class="text-center mt-2" style="">
                <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
            </div>
            {/if}
            {#if !loading}
            <div class="card mt-3 bg-xgrey">
                <div class="card-body text-center pb-5">
                    <div class="row">
                        <div class="col-12 mt-2 mb-3" style="justify-content: center;text-align:center;">
                            <img src="{dataSetting.logo}" class="img-fluid" style="width: 120px;">
                        </div>
                    </div>
                    
                    <div class="mb-3">
                        <label for="creditwd" class="form-label text-warning">กรอกจำนวนเงินที่ต้องการถอน</label>
                        <input type="text" class="form-control rounded-pill text-center mb-1" id="creditwd" style="text-align: center !important; justify-content: center !important;" placeholder="" bind:value={creditwd} on:keypress={()=>numberonly(event)}>
                        {#if isMember}
                        
                        <small class="text-white">ฝากขั้นต่ำ <span class="text-danger">{dataMember.dataGroup.min_withdraw}</span> บาท สูงสุด <span class="text-danger">{dataMember.dataGroup.max_withdraw}</span> บาท</small>
                        
                        {/if}
                    </div>
                    <div class="row">
                        <div class="col-12 text-center d-grid gap-2">
                            {#if isbutton}
                            <button type="button" class="btn btn-dark rounded-pill btn-gd" on:click={() => getBalanceWD()}>ยืนยันถอนเงิน</button>
                            {/if}
                        </div>
                    </div>
                    
                </div>
            </div>
            {/if}
        </div>
    </div>
</div>
<div class="themes-home-section" style="display: none;display:flex;">

</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
    .btn-gd{
        /* --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.6rem;
        font-weight: 300; */
    }
    .bg-dk{
        background-color: black;
    }
    .text-sm{
        font-weight: 300;
        font-size: 0.6rem;
    }
    .pointer{
        cursor: pointer;
    }
    .bg-black{
        background: #000000ad !important;
    }
</style>